/* BPSC*/
export const GET_GENDER_DROPDOWN_LIST = "get_gender_dropdown_list";
export const GET_ID_TYPE_DROPDOWN_LIST = "get_id_type_dropdown_list";
export const SET_SECURITY_QUESTIONS = "set_security_questions";
export const SET_GET_MOBILE_OTP_FLAG = "set_get_mobile_otp_flag";
export const SET_GET_EMAIL_OTP_FLAG = "set_get_email_otp_flag";
export const SET_HELPLINE_DETAILS = "set_helpline_details";
export const SET_CONFIGURATION_DIGILOCKER_FLAG = "set_configuration_digilocker_flag";
/* ------------------------------------------------------------------------------------------------ */
export const ERROR_ACTION = "set_and_display_error";
export const SET_REGISTRATION_RESPONSE = "set_registration_response";
export const SET_USER_SESSION = "set_user_session";
export const LOGOUT_CLEAR_USER_SESSION = "logout_clear_user_session";
export const SET_CAPTCHA_IMAGE = "set_captcha_image";
export const SET_ADDRESS_INFO = "set_address_info";
export const SET_EXPERIENCE_INFO = "SET_EXPERIENCE_INFO";
export const PERSONAL_INFORMATION = " PERSONAL_INFORMATION";
export const DASHBOARD_COUNT = "dashboard_count"
export const SET_OTHER_INFORMATION = "set_other_information";
export const SET_QUALIFICATION_INFORMATION = "set_qualification_information";
export const CLEAR_QUALIFICATION_INFORMATION =
  "clear_qualification_information";
export const ADD_QUALIFICATION = "add_qualification";
export const ADD_EXPERIENCEINFO = "add_experienceinfo";
export const EDIT_EXPERIENCEINFO = "edit_experienceinfo";
export const EDIT_QUALIFICATION = "edit_qualification";
export const IS_QUALIFICATION_TYPE_CHANGED_BY_DROPDOWN =
  "is_qualification_type_changed_by_dropdown";
export const SET_EXPERIENCEINFO_EDIT_FLAG = "set_experienceinfo_flag";
export const EDIT_QUALIFICATION_DONE_RESET = "edit_qualification_done_reset";
export const SET_CURRENT_EDIT_QUALIFICATION_INDEX =
  "set_current_edit_qualification_index";
export const SET_DISPLAYABLE_QUALIFICATION_LIST =
  "set_displayable_qualification_list";
export const SET_PROFILE_CREATION_LOOKUPS = "set_profile_creation_lookups";
export const SET_STATES = "set_states";
export const SET_DISTRICTS = "set_districts";
export const SET_DISTRICTS_CORRESPONDENCE = "set_district_correspondence";
export const SET_TALUKAS = "set_talukas";
export const SET_TALUKAS_CORRESPONDENCE = "set_talukas_correspondence";
export const SET_VILLAGES = "set_villages";
export const SET_VILLAGES_CORRESPONDENCE = "set_villages_correspondence";
export const SET_ISSUING_DISTRICTS = "set_issuing_districts";
export const SET_PERSONAL_INFO = "set_personal_info";
export const SET_QUALIFICATION_TYPES = "set_qualification_types";
export const SET_QUALIFICATION_NAMES = "set_qualification_names";
export const SET_SUBJECTS = "set_subjects";
export const SET_UNIVERSITIES = "set_universities";
export const SHOW_LOADER = "show_loader";
export const HIDE_LOADER = "hide_loader";
export const SET_SELECTED_QUALIFICATION_TYPE =
  "set_selected_qualification_type";
export const SET_SELECTED_INTERNSHIP_STREAM =
  "SET_SELECTED_INTERNSHIP_STREAM";
export const SET_SELECTED_INTERNSHIP_FROM_DATE =
  "SET_SELECTED_INTERNSHIP_FROM_DATE";
export const SET_SELECTED_INTERNSHIP_TO_DATE =
  "SET_SELECTED_INTERNSHIP_TO_DATE";
export const SET_SELECTED_INTERNSHIP_ISSUE_DATE =
  "SET_SELECTED_INTERNSHIP_ISSUE_DATE";

export const SET_UPLOADED_PHOTO = "set_uploaded_photo";
export const SET_IMAGE_SRC = "set_image_src";
export const SET_LIVEIMAGE_SRC = "set_liveimage_src";
export const SET_CROPE_IMAGE_SRC = "set_crope_image_src";
export const SET_CROPE_LIVEIMAGE_SRC = "set_crope_Liveimage_src";
export const SET_SIGNATURE_SRC = "set_signature_src";
export const SET_HINDI_SIGNATURE_SRC = "set_hindi_signature_src";
export const SET_CROP_SIGNATURE_SRC = "set_crop_signature_src";
export const SET_CROP_HINDI_SIGNATURE_SRC = "set_crop_hindi_signature_src";
export const SET_IMAGE_SIGNATURE_FLAG = "set_image_signature_flag";
export const SET_PROFILE_STATUS = "set_profile_status";
export const SET_A_SUBMITTABLE_FLG = "set_a_submittable_flg";
export const SET_DISABLE_ALL_TAB_SAVE = "set_disable_all_tab_save";
export const SET_GET_EMAIL_OTP_RESPONSE = "set_get_email_otps_response";
export const SET_GET_MOBILE_OTP_RESPONSE = "set_get_mobile_otps_response";
export const SET_FORGOT_PASSWORD_STATE = "set_forgot_password_state";
export const SET_ADVERTISEMENT_LIST = "set_advertisement_list";
export const SET_ADVERTISEMENT_DETAILS = "set_advertisement_details";
export const SET_ADVERTISEMENT_SHOW_DETAILS = "set_advertisement_show_details";
export const SET_APPLICATION_ELIGIBILITY_INFO =
  "set_application_elgibility_info";
export const SET_APPLICATION_RE_CHECK_ELIGIBILITY_INFO =
  "set_application_re_check_eligibility_info";
export const SET_APPLICATION_POST_PREF_LIST_RE_CHECK_ELIGIBILITY =
  "set_application_post_pref_list_re_check_eligibility";
export const SET_APPLICATION_POST_PREF_LIST = "set_application_post_pref_list";
export const SET_APPLICATION_IS_REQST_IN_PROGRESS =
  "set_application_is_reqst_in_progress";
export const SET_PROCEED_TO_PAYMENT = "set_proceed_to_payment";
export const SET_GOTO_MYACCOUNT = "set_goto_myaccount";
export const SET_APPLICATION_ID = "set_application_id";
export const SET_PROFILE_INFO_DISPLAY = "set_profile_info_display";
export const SET_API_REPO_VERSION = "set_api_repo_version";
export const SET_MY_APPLICATION_LIST = "set_my_application_list";
export const SET_UPLOADED_DOCUMENT = "set_uploaded_document";
export const SET_UPLOAD_DOCUMENT_INFO_ID = "set_upload_document_info_id";
export const SET_HAS_PENDING_TRANSACTIONS = "set_has_pending_transactions";
export const SET_CHANGE_PASS_MODAL = "set_change_pass_modal";
export const SET_PROFILE_SUMMARY_INFO = "set_profile_summary_info";
export const SET_UPDATE_PROFILE_MODAL = "set_update_profile_modal";
export const SET_APPLICATION_DETAILS = "set_application_details";
export const SET_SHOW_APPLICATION_DETAILS_FLAG =
  "set_show_pplication_details_flag";
export const SET_PRINT_PROFILE = "set_print_profile";
export const SET_PROFILE_VIEW = "set_profile_view";
export const SET_EMAIL_MOBILE_OTP = "set_email_mobile_otp";
export const SET_VERIFY_OTP_FLAG_EMAIL = "set_verify_otp_flag_email";
export const SET_VERIFY_OTP_FLAG_MOBILE = "set_verify_otp_flag_mobile";
export const SET_APPLICATION_RECEIPT = "set_application_receipt";
export const SET_SPORT_DETAILS_LIST = "set_sport_details_list";
export const EDIT_SPORT_DETAILS_LIST = "edit_sport_details_list";
export const SET_VERIFY_OTP_FLAG_LOGIN = "set_verify_otp_login";
export const SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD =
  "set_verify_otp_forgot_password";
export const CLEAR_SPORT_DTO = "clear_sport_dto";
export const SET_USER_LOGIN_DATA = "set_user_login_data";
export const SET_UPDATE_PROFILE_DONE = "set_update_profile_done";
export const SET_BACK_TO_MY_ACCOUNT = "set_back_to_my_account";
export const SET_GET_USERNAME_OTP_RESPONSE = "set_get_username_otp_response";
export const SET_SECURITY_QUESTIONS_FORGOT_PASSWORD =
  "set_security_question_forgot_password";
export const SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE =
  "set_verify_otp_flag_registration_mobile";
export const SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL =
  "set_verify_otp_flag_registration_email";
export const SET_GUIDELINE_LINKS = "set_guideline_links";
export const SET_LOCK_UNLOCK_PROFILE_FLG = "SET_LOCK_UNLOCK_PROFILE_FLG";


export const SET_ADMIN_DEPARTMENTS = "set_admin_departments";
export const SET_VERIFY_DETAILS = "set_verify_details";
export const SET_ADMIN_OTP_VERIFIED_FLAG = "set_admin_otp_verified_flag"
export const SET_VERIFY_OTP_FLAG_FORGOT_EMAIL =
  "set_verify_otp_flag_forgot_email";
export const SET_VERIFY_OTP_FLAG_FORGOT_MOBILE =
  "set_verify_otp_flag_forgot_mobile";
export const SET_CHANGE_CENTER_FLAG = "set_change_center_flag";
export const SET_PAYMENT_HISTORY_MODAL = "set_payment_history_modal";
export const SET_PAYMENT_HISTORY_LIST = "set_payment_history_list";
export const SET_UPDATE_POST_PREF_FLAG = "set_update_post_pref_flag";
export const SET_EXAM_CENTER_LIST = "set_exam_center_list";
export const SET_CHECK_ELIGIBILITY_DISABLE = "set_check_eligibilty_disable";
export const SET_CORRESPONDENCE_DATA = "set_correspondence_data";
export const SET_APPLICATION_STAGE_USERDATA = "set_application_stage_userdata";
export const SET_SECURITY_QUESTIONS_FOR_RESET_EMAIL =
  "set_security_questions_for_reset_email";
export const SET_SECURITY_ANSWERS_FOR_RESET_EMAIL =
  "set_security_answers_for_reset_email";
export const SET_SECURITY_QUESTIONS_FOR_LOGIN =
  "set_security_questions_for_login";
export const SET_SECURITY_ANSWERS_FOR_LOGIN = "set_security_answers_for_login";
export const SET_MODULE_ENABLE_DISABLE = "set_module_enable_disable";
export const SET_API_CALL_FOR_MODULE = "set_api_call_for_module";
export const SET_MODULE_LIST = "set_module_list";
export const SET_EXPERIENCE_TABLE_LIST = "set_experience_table_list";
export const SET_LOG_OUT_OTP_DATA = "sel_logout_otp_data";
export const SET_MARKSHEET_LIST = "set_marksheet_list";
export const SET_RETOTALING_POST_SUBJECTS = "set_retotaling_post_subjects";
export const SET_RETOTALING_REQUESTS = "set_retotaling_requests";
export const SET_RETOTALING_REQUEST_ID = "set_retotaling_request_id";
export const SET_EASEBUZZ_ACCESS_KEY = "set_easebuzz_access_key";
export const GET_OTP_DATA_EMAIL = "get_otp_data_email";
export const GET_OTP_DATA_MOBILE = "get_otp_data_mobile";
export const GET_OTP_DATA_USERNAME = "get_otp_data_username";
export const SET_POST_PREFERENCE_DETAILS = "set_post_preference_details";
export const SET_ADDITIONAL_RES_ENV_DATA = "set_additional_res_env_data";
export const SET_ALL_DEPARTMENTS_DATA = "set_all_departments_data";
export const SET_ALLDEPARTMENTS_DATA = "set_alldepartments_data";
export const SET_ALL_DISABILITIES_DATA = "set_all_disabilities_data";
export const GET_ALL_CANDIDATE_INFO = "get_all_candidate_info";
export const GET_OBJ_REQ_DATA = "get_obj_req_data";
export const GET_DROPDOWN_OBJ_REQ = "get_dropdown_obj_req";
export const SET_OBJREQ = "set_objreq";
export const SET_ALL_OBJREQ = "set_all_objreq";
export const SET_OBJ_REQ_ID = "set_obj_req_id";
export const GET_POST_OBJREP = "get_post_objrep";
export const GET_OBJECTION_QUESTIONS = "get_objection_questions";
export const SET_PUBLICATION_TYPE_DATA = "set_publication_type_data";
export const SET_IS_MOBILE_NO_ALREADY_EXIST_FLG =
  "set_is_mobile_no_already_exist_flg";
export const SET_IS_EMAIL_ID_ALREADY_EXIST_FLG =
  "set_is_email_id_already_exist_flg";
export const SET_ADDITIONAL_QUESTIONS = "set_addtional_questions";
export const GET_NAME_OF_INDEXING_BODIES = "get_name_of_indexing_bodies";
export const GET_TYPE_OF_ARTICLES = "get_type_of_articles";
export const GET_ALL_JOB_DESIGNATION_LIST = "get_all_job_designation_list";
export const SET_EXAM_DISPLAY_NAME_FOR_ADMIT_CARD =
  "set_exam_display_name_for_admit_card";
export const GET_LOGIN_STATUS = "get_login_status";
export const SET_DOWNLOAD_INTERVIEW_PT_LETTER_DATA =
  "set_download_interview_pt_letter_data";
export const SET_DIGILOCKER_URL = "set_digilocker_url";
export const SET_DIGILOCKER_ACCESSTOKEN_DATA =
  "set_digilocker_accesstoken_data";
export const SET_PROFILE_CREATION_LOOKUP = "set_profile_creation_lookup";
export const SET_PERSONAL_DIGILOCKER_STATUS = "set_personal_digilocker_status";
export const SET_BOARDS_LIST = "set_boards_list";
export const SET_CENTER_SELECTION_STATUS = "set_center_selection_status";
export const SET_MAX_CENTER_SELECTION_NUMBER =
  "set_max_center_selection_number";

// actionTypes.js for Qualifications
export const SET_IS_EDITING = "SET_IS_EDITING";
export const TOGGLE_IS_EDITING = "TOGGLE_IS_EDITING";
export const SET_IS_EDITING_INDEX = "SET_IS_EDITING_INDEX";
export const SET_EDITING_INDEX = "SET_EDITING_INDEX";
export const SET_EDIT_INDEX = "SET_EDIT_INDEX";
export const SET_BUTTONS_VISIBLE = "SET_BUTTONS_VISIBLE";
export const TOGGLE_BUTTONS_VISIBLE = "TOGGLE_BUTTONS_VISIBLE";

export const GRIEVANCE_DETAILS = "grievance_details";
export const GRIEVANCE_LIST = "grievance_list";
export const GET_GRIEVANCE_TYPE_DROPDOWN_LIST = "grievance_types";
export const SET_VERIFY_OTP_FLAG_GRIEVANCE_MOBILE = "set_verify_otp_flag_grievance_mobile";
export const SET_GRIEVANCE_TABLE_LIST = "set_grievance_table_list";

export const GET_ADVERTISEMENT_TYPE_DROPDOWN_LIST = "advertisementDropdown";
export const GET_SUB_TYPE_GRIEVANCE_DROPDOWN_LIST = "get_sub_type_grievance_dropdown_list";
export const GET_TYPE_GRIEVANCE_DROPDOWN_LIST = "GET_TYPE_GRIEVANCE_DROPDOWN_LIST";
export const SET_SHOW_MODAL_VALUE = "SET_SHOW_MODAL_VALUE";
export const SET_IS_PROFILE_PHOTO_VALIDATE_VALUE = "SET_IS_PROFILE_PHOTO_VALIDATE_VALUE";
export const SET_IS_LIVE_PHOTO_VALIDATE_VALUE = "SET_IS_LIVE_PHOTO_VALIDATE_VALUE";
export const SET_LIVE_PHOTO_TIMER = "SET_LIVE_PHOTO_TIMER";
export const IS_APPLICATION_LIVE_PHOTO_ENABLE = "IS_APPLICATION_LIVE_PHOTO_ENABLE";
export const SET_CURRENT_EDIT_INTERNSHIP_INDEX =
  "set_current_edit_internship_index";
export const SET_INTERNSHIP_INFORMATION = "set_internship_information";
export const ADD_INTERNSHIP = "add_internship";
export const UPDATE_INTERNSHIP = "UPDATE_INTERNSHIP";
export const ADD_INTERNSHIP_LIST = "ADD_INTERNSHIP_LIST";
export const EDIT_INTERNSHIP = "edit_internship";
export const CLEAR_INTERNSHIP_INFORMATION =
  "clear_internship_information";
export const SET_INTERNSHIP_LIST = "SET_INTERNSHIP_LIST";
export const SET_SELECTED_INTERNSHIP_TYPE =
  "set_selected_internship_type";
export const SET_TOGGLE_EDIT_MODE = "SET_TOGGLE_EDIT_MODE";
export const INTERNSHIP_TO_BE_EDIT = "INTERNSHIP_TO_BE_EDIT";
export const SET_QUALIFICATIONS_LIST = "SET_QUALIFICATIONS_LIST";
export const SET_AUTHENTICATION_DATA_OBJ = "SET_AUTHENTICATION_DATA_OBJ";
export const SET_CITIZENSHIP_WARNING_MSG = "SET_CITIZENSHIP_WARNING_MSG";


// Admin


// export const SET_SECURITY_QUESTIONS = 'set_security_questions';
// export const ERROR_ACTION = 'set_and_display_error';
// export const SET_REGISTRATION_RESPONSE = 'set_registration_response';
// export const SET_USER_SESSION = 'set_user_session';
// export const LOGOUT_CLEAR_USER_SESSION = 'logout_clear_user_session';
// export const SET_CAPTCHA_IMAGE = "set_captcha_image";
export const SET_DEPARTMENTS = "set_departments";
export const SET_GET_OTP_RESPONSE = "set_get_otp_response";
// export const SET_VERIFY_OTP_FLAG_EMAIL = "set_verify_otp_flag_email";
// export const SET_VERIFY_OTP_FLAG_MOBILE = "set_verify_otp_flag_mobile";
export const SET_GET_ACTIVE_USER = "set_get_active_user";
export const SET_GET_APPROVAL_USER = "set_get_approval_user";
export const SET_ROLE_BY_DEPT = "set_role_by_dept";
export const SET_SUPERVISOR_BY_ROLE = "set_supervisor_by_role";
export const SET_VERIFY_USER = "set_verify_user";
export const SET_VERIFY_SHOW = "set_verify_show";
export const SET_EMAIL_OTP_FLAG_VERIFY = "set_email_otp_flag_verify";
export const SET_MOBILE_OTP_FLAG_VERIFY = "set_mobile_otp_flag_verify";
export const SET_OTP_VERIFICATION_EMAIL_STATUS = "set_otp_verification_email_status";
export const SET_OTP_VERIFICATION_MOBILE_STATUS = "set_otp_verification_mobile_status";
export const SET_BOTH_OTP_VERIFICATION = "set_both_otp_verification_status";
export const SET_RESET_PWD_SHOW = "set_reset_pwd_show";
export const SET_USERNAME = "set_username";
export const SET_USER_NAME_FOR_LOGIN = "set_user_name_for_login";
// export const SET_API_REPO_VERSION = "set_api_repo_version";
export const SET_GET_ACTIVE_ADVERTISEMENT = "set_get_active_advertisement";
export const SET_GET_PAST_ADVERTISEMENT = "set_get_past_advertisement";
// export const SHOW_LOADER = "show_loader";
// export const HIDE_LOADER = "hide_loader";
// export const SET_GET_EMAIL_OTP_RESPONSE = "set_get_email_otps_response";
// export const SET_GET_MOBILE_OTP_RESPONSE = "set_get_mobile_otps_response";
// export const SET_VERIFY_OTP_FLAG_LOGIN = "set_verify_otp_login";
// export const SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD = "set_verify_otp_forgot_password";
// export const SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE = 'set_verify_otp_flag_registration_mobile';
// export const SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL = 'set_verify_otp_flag_registration_email';
// export const SET_FORGOT_PASSWORD_STATE = "set_forgot_password_state";
export const SET_CHANGE_PWD_MODAL = "set_change_pwd_modal";
export const SET_ADVERTISEMENT_VIEW = "set_advertisement_view";
export const SET_CHALLAN_DETAILS = "set_challan_details";
export const SET_CANDIDATES_CHALLAN_DETAILS = "set_candidates_challan_details";
export const SET_CANDIDATES_CHALLAN_UPLOAD = "set_candidates_challan_upload";
export const SET_ADVERTISEMENT_DETAILS_AND_CANDIDATE_LIST = "set_advertisement_details_and_candidate_list";
export const SET_SHOW_VERIFY_DOCUMENT_TABLE = "set_show_verify_document_table";
export const SET_SHOW_APPROVE_DOC_MODAL = "set_show_approve_doc_modal";
export const SET_SHOW_UPDATE_APPROVE_DOC_MODAL = "set_show_update_approve_doc_modal";
export const SET_SHOW_REJECT_DOC_MODAL = "set_show_reject_doc_modal";
export const SET_DOCUMENTLIST_BY_CANDIDATE = "set_documentlist_by_candidate";
export const SET_CANDIDATES_BY_ADVERTISEMENT = "set_candidates_by_advertisement";
export const SET_VIEW_DOC_MODAL = "set_view_doc_modal";
export const SET_VIEW_EXPERIENCE_AND_QUALIFICATION_MODAL = "set_view_experience_and_qualification_modal";
export const SET_SHOW_APPROVE_EXPERIENCE_AND_QUALIFICATION_DOC_MODAL = "set_show_approve_experience_and_qualifiacation_doc_modal";
export const SET_USER_BY_ADVERTISEMENT = "set_user_by_advertisement";
export const SET_PROFILE_INFO_BY_CANDIDATE = "set_profile_info_by_candidate";
export const SET_APPROVAL_DOC_LIST = "set_approval_doc_list";
export const SET_CANCEL_REJECT_APPLICATIONS_LIST = "set_cancel_reject_applications_list";
export const SET_CANCEL_REJECT_APPLICATIONDATA_BY_ADVERTISEMENT = "SET_CANCEL_REJECT_APPLICATIONDATA_BY_ADVERTISEMENT";
// export const SET_ADVERTISEMENT_DETAILS = "set_advertisement_details";
export const SET_APPROVAL_ACTION_HISTORY = "set_approval_action_history";
export const SET_SHOW_ACTIVE_TAB_CANDIDATE_DETAILS = "set_show_active_tab_candidate_details";
export const ADVERTISEMENT_LIST_FOR_DOCUMENT_APPROVAL = "advertisement_list_for_document_approval";
export const SET_ADVERTISEMENT_DETAILS_AND_DOC_APPROVAL_LIST = "set_advertisement_details_and_doc_approval_list";
export const CANDIDATE_LIST_FOR_CHECK_ELIGIBILTY = "candidate_list_for_check_eligibilty";
export const ACTIVE_ADVERTISEMENT_LIST = "active_advertisement_list";
export const SET_ADVERTISEMENT_DETAILS_FOR_CANDIDATE = "set_advertisement_details_for_candidate";
// export const SET_APPLICATION_ELIGIBILITY_INFO = "set_application_eligibility_info";
// export const SET_PROFILE_INFO_DISPLAY = "set_profile_info_display";
// export const SET_PROFILE_CREATION_LOOKUPS = "set_profile_creation_lookups";
// export const SET_QUALIFICATION_TYPES = "set_qualification_types";
// export const SET_APPLICATION_RE_CHECK_ELIGIBILITY_INFO = "set_application_re_check_eligibility_info";
// export const SET_APPLICATION_POST_PREF_LIST_RE_CHECK_ELIGIBILITY = "set_application_post_pref_list_re_check_eligibility";
export const SET_ELIGIBILITY_BUTTON_DISABLE = "set_eligibility_button_disable";

export const SET_GET_ALL_DOCUMENTS_TYPE = "set_get_all_documents_type";
export const SET_GET_DOCUMENTS_TYPE = "set_get_documents_type";
export const SET_ADD_DOCUMENTS_TYPE = "set_add_documents_type";
export const SET_DOCUMENT_TYPE_PAGE_NO_COUNTER = "set_document_type_page_no_counter";

export const SET_GET_ALL_QUALIFICATION_TYPE = "set_get_all_qualification_type";
export const SET_GET_QUALIFICATION_TYPE = "set_get_qualification_type";
export const SET_ADD_QUALIFICATION_TYPE = "set_add_qualification_type";
export const SET_QUALIFICATION_TYPE_PAGE_NO_COUNTER = "set_qualification_type_page_no_counter";

export const SET_GET_ALL_QUALIFICATION_NAME = "set_get_all_qualification_name";
export const SET_GET_QUALIFICATION_NAME = "set_get_qualification_name";
export const SET_ADD_QUALIFICATION_NAME = "set_add_qualification_name";
export const SET_QUALIFICATION_NAME_PAGE_NO_COUNTER = "set_qualification_name_page_no_counter";

// export const SET_QUALIFICATION_NAMES = "set_qualification_names";
export const SET_QUALIFICATION_SUBJECTS = "set_qualification_subject_names";
export const SET_QUALIFICATION_SUBJECTS_PAGE_NO_COUNTER = "set_qualification_subject_page_no_counter";
export const SET_QUALIFICATION_SUBJECT = "set_qualification_subject";

export const SET_QUALIFICATION_TYPES_COMBO = "set_qualification_types_combo";
export const SET_QUALIFICATION_NAMES_COMBO = "set_qualification_names_combo";

// export const SET_UNIVERSITIES = "set_universities";
export const SET_UNIVERSITIES_PAGE_NO_COUNTER = "set_universities_page_no_counter";
export const SET_UNIVERSITY = "set_university";
export const SET_ADMIN_UNIVERSITY_STATES = "set_Admin_university_states";
export const SET_MODULES_LIST = "set_modules_list";
export const SET_TYPES_LIST = "set_types_list";
export const SET_PARENT_LABELS_LIST = "set_parent_labels_list";
export const SET_LOOKUP_OPTIONS = "set_lookup_options";
export const SET_LOOKUP_OPTIONS_PAGE_NO_COUNTER = "set_lookup_options_page_no_counter";
export const SET_LOOKUP_OPTION = "set_lookup_option";
export const SET_PARENT_LOOKUP_DATA = "set_parent_lookup_data";
export const SET_PARENT_TYPE_LIST = "set_parent_type_list";

export const SET_STATE = "set_state";
export const SET_ALL_STATES = "set_all_states";
export const SET_ALL_STATES_PAGE_NO_COUNTER = "set_all_states_page_no_counter";

export const SET_ALL_DISTRICT_STATES = "set_all_district_states";
export const SET_ALL_DISTRICT = "set_all_district";
export const SET_DISTRICT = "set_district";
export const SET_ALL_DISTRICT_PAGE_NO_COUNTER = "set_all_district_page_no_counter";

export const SET_ALL_TALUKA_STATES = "set_all_taluka_states";
export const SET_ALL_TALUKA_DISTRICTS = "set_all_taluka_districts";
export const SET_ALL_TALUKA = "set_all_taluka";
export const SET_TALUKA = "set_taluka";
export const SET_ALL_TALUKA_PAGE_NO_COUNTER = "set_all_taluka_page_no_counter";

export const SET_ALL_VILLAGE_STATES = "set_all_village_states";
export const SET_ALL_VILLAGE_DISTRICTS = "set_all_village_districts";
export const SET_ALL_VILLAGE_TALUKAS = "set_all_village_talukas";
export const SET_ALL_VILLAGE = "set_all_village";
export const SET_VILLAGE = "set_village";
export const SET_ALL_VILLAGE_PAGE_NO_COUNTER = "set_all_village_page_no_counter";
export const SET_UPLOAD_MARKSHEET_LIST = "set_upload_marksheet_list";
export const SET_APPLICATION_STAGES_VIEW = "set_application_stages_view"
export const SET_ALL_STAGES_LIST = "set_advertisement_stages_list";
export const SET_ADVT_DETAILS = "set_advertisement_details";
export const SET_ADVT_POSTS_DATA = "set_advertisement_retotaling_data";
export const SET_EXAMSUBJECT = "set_exam_subject";
export const SET_ALL_EXAMSUBJECTS = "set_all_exam_subjects";
export const SET_PARENT_EXAMSUBJECT_DATA = "set_all_parent_exam_subject";
export const SET_ALL_EXAMSUBJECT_PAGE_NO_COUNTER = "set_all_exam_subject_page_no_counter";

export const SET_STAGE = "set_stage";
export const SET_ALL_STAGES = "set_all_stages";
//export const SET_PARENT_STAGE_DATA = "set_all_parent_stage";
export const SET_ALL_STAGES_PAGE_NO_COUNTER = "set_all_stage_page_no_counter";
export const SET_ALL_STAGES_CONFIG_LIST = "set_all_stages_config_list";
export const SET_ALL_SUBJECTS_LIST = "set_all_subjects_list"
export const SET_ALL_VENUE_LIST = "set_all_venue_list";
export const SET_ALL_EXAM_CENTERS_LIST = "set_all_exam_centers_list";
export const SET_ALL_STATES_LIST = "set_all_states_list";
export const SET_ALL_DISTRICTS_LIST = "set_all_districts_list";
export const SET_ALL_SUBDISTRICTS_LIST = "set_all_subdistricts_list";
export const SET_ALL_VILLAGES_LIST = "set_all_villages_list";
export const SET_ALL_COORDINATOR_ROLES_LIST = "set_all_Coordinator_roles_list";
export const SET_ALL_EXAM_MODES_LIST = "set_all_exam_modes_list";
export const SET_ALL_COORDINATOR_GENDERS_LIST = "set_all_Coordinator_genders_list";
export const SET_ALL_UNAPPROVAL_ENTITY_LIST = "set_all_unapproval_entity_list";
export const SET_ALL_APPROVED_ENTITY_LIST = "set_all_approved_entity_list";
export const SET_UPLOAD_CSV = "set_upload_csv";

export const SET_GET_ALL_REPORT_DATA = "set_get_all_report_data";
export const SET_REPORT_DATA_PAGE_NO_COUNTER = "set_report_data_page_no_counter";
export const SET_DEPARTMENT_COMBO = "set_department_combo";
export const SET_EXAM_COMBO = "set_exam_combo";
export const SET_GROUP_COMBO = "set_group_combo";
export const SET_ADV_NO = "set_adv_no";
export const SET_DATE_DATA = "set_date_data";
export const GET_VENUE_ERRORLIST = "get_venue_errorlist";
export const SET_UNAPPROVAL_PAGE_NO_COUNTER = "set_unapproval_page_no_counter";
export const SET_APPROVED_PAGE_NO_COUNTER = "set_approval_page_no_counter";

export const SET_ALL_REQUISITION = "set_all_requisition";
export const SET_REQUISITION_DATA = "set_requisition_data";
export const SET_ALL_REQUISITION_DROPDOWN = "set_all_requisition_dropdown";
export const SET_ALL_REQUISITION_PAGE_NO_COUNTER = "set_all_requisition_page_no_counter";
export const SET_ALL_REQUISITION_POST_DROPDOWN = "set_all_requisition_post_dropdown";
export const SET_ALL_REQUISITION_TYPE_DROPDOWN = "set_all_requisition_type_dropdown";
export const SET_ALL_REQUISITION_DEPARTMENT_DROPDOWN = "set_all_requisition_department_dropdown";
export const SET_ALL_REQUISITION_SPECIALISATION_DROPDOWN = "set_all_requisition_specialisation_dropdown";
export const SET_ALL_REQUISITION_INSTITUTION_DROPDOWN = "set_all_requisition_institution_dropdown";
export const SET_ALL_REQUISITION_GROUP_DROPDOWN = "set_all_requisition_group_dropdown";
export const SET_ALL_REQUISITION_CLASS_DROPDOWN = "set_all_requisition_class_dropdown";
export const SET_ALL_REQUISITION_STATUS_DROPDOWN = "set_all_requisition_status_dropdown";
export const SET_ALL_ADVERTISEMENT_DROPDOWN = "set_all_advertisement_dropdowm";
export const SET_ALL_ADMINISTRATIVE_DEPARTMENT_DROPDOWN = "set_all_administrative_department";

export const SET_SPECIALIZATION = "set_specialisation";
export const SET_ALL_SPECIALIZATION = "set_all_specialisation";
export const SET_ALL_SPECIALIZATION_PAGE_NO_COUNTER = "set_all_specialisation_page_no_counter";
export const SET_REQUISITIONPOST = "set_requisition_post";
export const SET_ALL_REQUISITIONPOST = "set_all_requisition_post";
export const SET_ALL_REQUISITIONPOST_PAGE_NO_COUNTER = "set_all_requisition_post_page_no_counter";


export const SET_REQDEPARTMENT = "set_requisition_department";
export const SET_ALL_REQDEPARTMENTS = "set_all_requisition_departments";
export const SET_ALL_REQDEPARTMENT_PAGE_NO_COUNTER = "set_all_requisition_department_page_no_counter";

export const SET_INSTITUTION = "set_institution";
export const SET_ALL_INSTITUTION = "set_all_institution";
export const SET_ALL_INSTITUTION_DROPDOWN = "set_all_drop_institution";

export const SET_ALL_INSTITUTION_PAGE_NO_COUNTER = "set_all_institution_page_no_counter";
export const SET_UPLOAD_VENUE_CSV_LIST = "set_upload_venue_csv_list";



export const SET_DEPARTMENT_NAMES_COMBO = "set_department_names_combo";
export const SET_EXAM_TYPES_COMBO = "set_exam_types_combo";
export const SET_POST_NAMES_COMBO = "set_post_names_combo";
export const SET_GROUP_NAMES_COMBO = "set_group_names_combo";
export const SET_ALL_ADVERTISEMENTREPORT = "set_all_adevertisement_report";
export const SET_ALL_ADVERTISEMENTREPORT_PAGE_NO_COUNTER = "set_all_advertisement_report_page_no_counter";
export const SET_RECRUITMENT_TYPES_COMBO = "set_recruitment_types_combo";

export const SET_ALL_DEPARTMENTWISESUMMARY = "set_all_departmentwise_summary_report";
export const SET_ALL_DEPARTMENTWISESUMMARY_PAGE_NO_COUNTER = "set_all_departmentwise_summary_report_page_no_counter";

export const SET_All_ADVERTISEMENT_REPORT_DATA = "set_advertisement_report_list";
export const SET_All_DEPARTMENTWISE_REPORT_DATA = "set_departmentwise_summary_report_list";
export const SET_All_REQUISITION_REPORT_DATA = "set_requisition_data_report_list";

export const GET_OTP_TIMER = "get_otp_timer";
export const GET_OTP_TIMER_MOBILE = "get_otp_timer_mobile";
export const GET_OTP_TIMER_EMAIL = "get_otp_timer_email";
// export const SET_APPLICATION_DETAILS = "set_application_details";
export const SET_PROFILE_DETAILS = "set_profile_details";

export const SET_ALL_DEBARRED_DATA = "set_all_debarred_data";
export const SET_ALL_DEBARRED_PAGE_NO_COUNTER = "set_all_debarred_page_no_counter";
export const SET_DEBARRED_DATA = "set_debarred_data";
export const SET_ALL_VENUES_LIST = "set_all_venues_list";
export const SET_ALL_DEBARRED_DROPDOWN = "set_all_debarred_dropdown";
export const SET_EVIDENCE_DATA = "set_evidence_data";
export const SET_GET_ALL_DASHBOARDS_USER_LIST = "set_get_all_dashboards_user_list";
export const SET_USERS_LIST_PAGE_NO_COUNTER = "set_users_list_page_no_counter";
export const SET_GET_ALL_ATTENDENT_LIST = "set_get_all_attendent_list";
export const SET_ATTENDENT_LIST_PAGE_NO_COUNTER = "set_attendent_list_page_no_counter";
export const SET_GET_ADVERTISEMENT_AND_EXAM_LIST = "set_get_advertisement_and_exam_list";
export const SET_ALL_EXAM_LIST = "set_all_exam_list";
export const SET_EXAM_PAGE_NO_COUNTER = "set_exam_page_no_counter";

export const SET_ALL_UPLOADED_DOCUMENTS = "set_all_uploaded_documents";
export const SET_ALL_VENUES = "set_all_venues";
export const SET_ALL_ADVERTISEMENTS = "set_all_advertisements";

export const SET_GET_ALL_DOCUMENT_LIST = "set_all_documents";
export const SET_DOCUMENT_LIST_PAGE_NO_COUNTER = "set_document_download_page_no_counter";
export const SET_GET_VENUE_DASHBOARD_COUNT = "set_get_venue_dashboard_count";
export const GET_ALL_ROLES = "get_all_roles";
export const GET_ADDITIONAL_QUESTIONS_DATA = "get_additional_questions_data";
export const GET_ADDITIONAL_ANSWERS_DATA = "get_additional_answers_data";

export const UPDATE_ATTENDENT_LIST = "update_attendent_list";
export const UPDATE_ATTENDENT_LIST_PAGE_NO_COUNTER = "update_attendent_list_page_no_counter";
export const SET_ALL_REUPLOAD_DOCLIST = "set_all_reupload_doclist";
export const SET_ALL_REDOWNLOAD_DOCLIST = "set_all_redownload_doclist";

export const SET_ADV_CIRCULAR = "set_adv_circular";

export const GET_ALL_COLLECTOR_VENUE = "get_all_collector_venue";
export const GET_COLLECTOR_ATTENDANCE_LIST = "get_collector_attendance_list";
export const SET_COLLECTOR_ATTENDANCE_LIST = "set_collector_attendance_list";
export const UPDATE_ATTENDENT_LIST_COLLECTOR = "update_attendent_list_collector";
export const UPDATE_ATTENDENT_LIST_COLLECTOR_PAGINATION = "update_attendent_list_collector_pagination";
export const SET_ALL_EXAM_LIST_COLLECTOR = "set_all_exam_list_collector";
export const SET_EXAM_PAGE_NO_COUNTER_COLLECTOR = "set_exam_page_no_counter_collector";

export const SET_GET_ALL_COLLECTOR_USER_LIST = "set_get_all_collector_user_list";
export const SET_USERS_LIST_PAGE_NO_COUNTER_COLLECTOR = "set_users_list_page_no_counter_collector";

export const SET_GET_COLLECTOR_DASHBOARD_COUNT = "set_get_collector_dashboard_count";
export const SET_GET_USER_DASHBOARD_COUNT = "set_get_user_dashboard_count";
export const SET_SCRUTINY_REPORT_DETAILS = "set_scrutiny_report_details";
export const SET_GET_POST_NAMES_DATA = "set_get_post_names_data";
export const SET_SHOW_SCRUTINY_REPORT_DETAILS = "set_show_scrutiny_report_details";
export const SET_EXPERIENCE_AND_QUALIFICATION_APPROVAL_ACTION_HISTORY = "set_experience_and_qualilfication_approval_action_history";
export const SET_GET_ALL_ACTIVE_ADVERTISEMENT = "set_get_all_active_advertisement";
export const SET_ADVERTISEMENT_LIST_PAGE_NO_COUNTER = "set_advertisement_list_page_no_counter";
export const SET_ALL_EXAM_CENTERS_LIST_BY_ADVT_ID = "set_all_exam_centers_list_by_advt_id";
export const SET_ALL_VENUES_LIST_BY_EXAM_CENTER_ID = "set_all_venues_list_by_exam_center_id";
export const SET_VENUE_DETAILS_BY_VENUE_ID = "set_venue_details_by_venue_id";
export const SET_ALL_ACTIVE_VENUE_ADVT = "set_all_active_venue_advt";
export const SET_ALL_ACTIVE_VENUE_ADVT_PAGE_NO_COUNTER = "set_all_active_venue_advt_page_no_counter";
export const SET_UPLOAD_TIME_TABLE_CSV = "set_upload_time_table_csv";
export const GET_UPLOAD_TIME_TABLE_CSV_LIST = "get_upload_time_table_csv_list";
export const SET_TIME_TABLE_CSV_LIST_PAGE_NO_COUNTER = "set_time_table_csv_list_page_no_counter";
export const GET_ACTIVE_EXAM_LIST_DETAILS = "get_active_exam_list_details";
export const GET_TIME_TABLE_DETAILS_BY_EXAM = "get_time_table_details_by_exam";
export const SET_EXAM_TYPE_FOR_TIME_TABLE = "set_exam_type_for_time_table";
export const SET_LANGUAGE_DETAILS_FOR_TIME_TABLE = "set_language_details_for_time_table";
export const SET_UPLOAD_TIME_TABLE_CSV_RESPONSE = "set_upload_time_table_csv_response";
export const SET_EXAM_PAPER_SET = "set_exam_paper_set";
export const SET_EXAM_PAPER_QUESTIONS_LIMIT = "set_exam_paper_questions_limit";
export const SET_EXAM_SUBJECTS_FOR_OBJECTION = "set_exam_subjects_for_objection";
export const SET_OBJECTION_ANSWER_KEY_DATA = "set_objection_answer_key_data";
export const SET_EXAM_SUBJECTS_FOR_OBJECTION_FILE = "set_exam_subjects_for_objection_file";
export const SET_OBJECTION_QUESTIONS = "set_objection_questions";
export const SET_ALL_OBJECTION_FILES_DATA = "set_all_objection_files_data";
export const SET_ALL_OBJECTION_FILES_PAGE_NO_COUNTER = "set_all_objection_files_page_no_counter";
export const SET_OBJECTION_FILE_IMAGE = "set_objection_file_image";
export const SET_EXAM_LIST_DETAILS_FOR_OBJECTION_REPORT = "set_exam_list_details_for_objection_report";
export const SET_EXAM_SUBJECT_LIST_FOR_OBJECTION_REPORT = "set_exam_subject_list_for_objection_report";
export const SET_EXAM_SUBJECT_QUESTIONS_LIST_FOR_OBJECTION_REPORT = "set_exam_subject_questions_list_for_objection_report";
export const SET_OBJECTION_REPORT_DATA = "set_objection_report_data";
export const SET_OBJECTION__COUNT_REPORT_DATA = "set_objection_count_report_data";
export const SET_OBJECTION_ATTACHMENT_REPORT_APPLICATIONS = "set_objection_attachment_report_applications";
export const SET_ALL_PAST_ADVT_DATA = "set_all_past_advt_data";
export const SET_ALL_EPMS_REPORT_CSV_DATA = "set_all_epms_re[prt_csv_data";
export const SET_ALL_REQUISITION_DISABILITY_CATEGORY_DROPDOWN = "set_all_requisition_disability_category_dropdown";
export const SET_CAST_CATEGORY_DETAILS = "set_cast_category_details";
export const SET_REQUIRED_LANGUAGE_DROPDOWN_DATA = "set_required_language_dropdown_data";
export const SET_TYPING_SHORTHAND_AND_TYPES_DROPDOWN_DATA = "set_typing_shorthand_and_types_dropdown_data";
export const SET_JOB_NATURE_DETAILS = "set_job_nature_details";
export const SET_REQUISITION_ID = "set_requisition_id";
export const SET_GET_PENDING_REQUISITION_DATA_DETAILS = "set_get_pending_requisition_data_details";
export const SET_PENDING_REQUISITION_LIST_PAGE_NO_COUNTER = "set_pending_requisition_list_page_no_counter";
export const SET_GET_SENT_FOR_APPROVAL_REQUISITION_DATA_DETAILS = "set_get_sent_for_approval_requisition_data_details";
export const SET_SENT_FOR_APPROVAL_REQUISITION_LIST_PAGE_NO_COUNTER = "set_sent_for_approval_requisition_list_page_no_counter";
export const SET_API_REQ_FLG = "set_api_req_flg";
export const SET_PENDING_APPROVAL_DETAILS = "set_pending_approval_details";
export const SET_PENDING_APPROVAL_DETAILS_PAGE_NO_COUNTER = "set_pending_approval_details_page_no_counter";
export const SET_YEAR = "set_year";
export const SET_ADMIT_CARD_TEMPLATE_DROPDOWN = "set_admit_card_template_dropdown";
export const SET_EXAM_TEMPLATE_LIST_FOR_IMPORT_ADMIT_CARD_CSV = "set_exam_template_list_for_import_admit_card_csv";
// export const SET_EXAM_CENTER_LIST = "set_exam_center_list";
export const GET_UPDATE_EXAM_TIME_TABLE_DATA = "get_update_exam_time_table_data";
export const GET_TIME_TABLE_DETAILS_BY_TEMPLATE_ID = "get_time_table_details_by_template_id";
export const SET_SEARCH_ADMIT_CARD_LIST = "set_search_admit_card_list";
export const SET_ADMIT_CARD_SEARCH_LIST_PAGE_NO_COUNTER = "set_admit_card_search_list_page_no_counter";
// export const GET_ALL_CANDIDATE_INFO = "get_all_candidate_info";
export const SET_PROFILE_SUMMARY_INFO_DATA = "set_profile_summary_info_data";
export const SET_PROFILE_INFO_DISPLAY_DATA = "set_profile_info_display_data";
export const SET_VENUE_DETAILS = "set_venue_details";
export const SET_APPLICATION_COUNT = "set_application_count";
export const SET_EXAM_DISPLAY_NAME_BY_EXAM_ID = "set_exam_display_name_by_exam_id";
export const GET_TIME_TABLE_LISTING = "set_time_table_listing";
export const GET_DATA_EXAM_TEMPLATE = "get_data_exam_template";
export const SET_VENUE_ADVERTISEMENT_LIST = "set_venue_advertisement_list";
export const SET_VENUE_ADVERTISEMENT_LIST_PAGE_NO_COUNTER = "set_venue_advertisement_list_page_no_counter";
export const SET_EXAM_SUBJECTS_LIST = "set_exam_subjects_list";
export const GET_APPLICATION_LISTING = "get_application_listing";
export const SET_NON_ASSIGNED_VENUE_ADVERTISEMENT_LIST = "set_non_assigned_venue_advertisement_list";
export const SET_NON_ASSIGNED_VENUE_ADVERTISEMENT_LIST_PAGE_NO_COUNTER = "set_non_assigned_venue_advertisement_list_page_no_counter";
export const SET_STAGE_STATUS_DESK_DROPDOWN = "set_stage_status_desk_dropdown";
export const SET_FORM_2_DATA_STATUS = "set_form_2_data_status";
export const SET_APPROVED_VENUE_DETAILS_FOR_ADMIT_CARDS_NOTIFICATION_SECTION = "set_approved_venue_details_for_admit_cards_notification_section";
export const GET_EXAM_STAFF_ERROR_LIST_FILE = "get_exam_staff_error_list_file";
export const SET_SCHEDULE_TYPE_LIST = "set_schedule_type_list";
export const SET_INTERVIEW_PT_LETTER_DROPDOWN_VALUES = "set_interview_pt_letter_dropdown_values";
export const SET_APPLICATION_DETAILS_FOR_CANDIDATE_MANAGEMENT = "set_application_details_for_candidate_management";
export const SET_LOOKUP_OPTIONS_DATA = "set_lookup_options_data";
export const GET_ALL_ADVERTISEMENT_LIST = "get_all_advertisement_list";
export const SET_ACTIVE_ADVERTISEMENT_LIST_PAGE_NO_COUNTER = "set_active_advertisement_list_page_no_conuter";
export const GET_INTERVIEW_SCHEDULE_LIST = "get_interview_schedule_list";
export const SET_INTERVIEW_REPORT_DATA = "set_interview_report_data";
export const SET_CANDIDATE_LIST = "set_candidate_list";
export const SET_APPLICATION_DETAILS_FOR_APPLICATION_PROFILE_REPORT = "set_application_details_for_application_profile_report";
// export const GET_NAME_OF_INDEXING_BODIES = "get_name_of_indexing_bodies";
// export const GET_TYPE_OF_ARTICLES = "get_type_of_articles";
export const GET_GRIEVANCE_LIST_WITH_PAGINATION = "GET_GRIEVANCE_LIST_WITH_PAGINATION";
export const SET_ADMIN_GRIEVANCE_SINGLE_LIST = "SET_ADMIN_GRIEVANCE_SINGLE_LIST";
export const GET_APPLICATION_LISTING_FOR_INTERVIEW_PT_LETTER = "get_application_listing_for_interview_pt_letter";
export const SET_INTERVIEW_INSTRUCTIONS_LIST = "set_interview_instructions_list";
export const SET_ADMIN_NAVIGATION_SIDEBAR_PANEL = "SET_ADMIN_NAVIGATION_SIDEBAR_PANEL";
export const GET_WEB_APP_VERSION = "GET_WEB_APP_VERSION";
export const GET_SINGLE_ADVT_DETAILS = "GET_SINGLE_ADVT_DETAILS";
export const GET_SLIDE_SHOW_ACTIVE_ADVT = "GET_SLIDE_SHOW_ACTIVE_ADVT";

export const EDIT_SET_LOCK_UNLOCK_PROFILE = "EDIT_SET_LOCK_UNLOCK_PROFILE";
export const SET_OTR_DETAILS = 'SET_OTR_DETAILS'
export const CANDIDATE_REPORTS = 'CANDIDATE_LIST_REPORTS'
export const SET_LIST_REPORT = "SET_LIST_REPORT";
export const GET_SINGLE_APPROVAL_DETAILS = "GET_SINGLE_APPROVAL_DETAILS";
export const GET_SUPERVIOSR_NAME_BY_ID = "GET_SUPERVIOSR_NAME_BY_ID";
export const SET_ROLE_BY_DEPT_BY_ID = "SET_ROLE_BY_DEPT_BY_ID";
export const ADVERTISEMENT_REPORT_DOWNLOAD = 'ADVERTISEMENT_REPORT_DOWNLOAD'
export const CANDIDATE_PAYMENT_LIST = 'candidate_payment_list';
export const SET_REPORT_RANGE = 'SET_REPORT_RANGE';










